"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TreeProvider", {
    enumerable: true,
    get: function() {
        return TreeProvider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _contexts = require("../contexts");
/**
 * @internal
 */ const rootSubtreeContextValue = {
    level: 1,
    contextType: 'subtree'
};
const TreeProvider = (props)=>{
    if (props.value.contextType === 'subtree') {
        return /*#__PURE__*/ _react.createElement(_contexts.SubtreeContext.Provider, {
            value: props.value
        }, props.children);
    }
    return /*#__PURE__*/ _react.createElement(_contexts.TreeContext.Provider, {
        value: props.value
    }, /*#__PURE__*/ _react.createElement(_contexts.SubtreeContext.Provider, {
        value: rootSubtreeContextValue
    }, props.children));
};
TreeProvider.displayName = 'TreeProvider';
